import SageScreen from "kit/SageScreen";
import React from "react";
import AccordianCard from "./accountSetup/AccordianCard";
import DownloadAppAccordianContent from "./accountSetup/DownloadAppAccordianContent";
import EducationAccordianContent from "./accountSetup/EducationAccordianContent";
import LoginAccordianContent from "./accountSetup/LoginAccordianContent";

const AccountSetup: React.FC = () => {
    const [selectedIdx, setSelectedIdx] = React.useState(0);

    const onIndexSelected = React.useCallback(
        (idx: number) => {
            if (selectedIdx === idx) {
                setSelectedIdx(-1);
            } else {
                setSelectedIdx(idx);
            }
        },
        [setSelectedIdx, selectedIdx]
    );

    return (
        <SageScreen>
            <div className="row align-item-center">
                <div className="col">
                    <h2>Setup Rend A Hand!</h2>
                    <p>
                        Following the steps on this page, your will be able to
                        get your Rend A Hand app setup!
                    </p>
                    <div className="accordion" id="setupAccordian">
                        <AccordianCard
                            indexSelected={onIndexSelected}
                            selectedIdx={selectedIdx}
                            idx={0}
                            title="1. Download and Install the Rend A Hand Desktop App"
                        >
                            <DownloadAppAccordianContent />
                        </AccordianCard>
                        <AccordianCard
                            selectedIdx={selectedIdx}
                            indexSelected={onIndexSelected}
                            idx={1}
                            title="2. Log In to the Rend A Hand Desktop App"
                        >
                            <LoginAccordianContent />
                        </AccordianCard>
                        <AccordianCard
                            selectedIdx={selectedIdx}
                            idx={2}
                            title="3. Use Rend A Hand!"
                            indexSelected={onIndexSelected}
                        >
                            <EducationAccordianContent />
                        </AccordianCard>
                    </div>
                </div>
            </div>
        </SageScreen>
    );
};

export default AccountSetup;
